// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c43e8f98","455":"17d00fc4","644":"76d87dd8","885":"b9a87deb"}[chunkId] + ".chunk.js";
};